import React, { useState, useEffect } from 'react';
import { DonationsForm } from './DonationsForm';
import { DonationGrid } from './DonationGrid';
import { useValidateEventoActual } from '../hooks/DonationsHook';
import { DetailModal } from '../_modals/DetailModal';

type Props = {};

const ViewAE: React.FC<Props> = ({}) => {
  const { catalog: eventoActual } = useValidateEventoActual();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [id, setId] = useState<number>(0);

  const [showSaleForm, setShowSaleForm] = useState<boolean>(false);
  const [showSaleBoton, setShowSaleBoton] = useState<boolean>(false);
  const [reloadInfo, setReloadInfo] = useState<number>(Math.random() * 40);
  const closeSecction = () => {
    setShowSaleForm(false);
    setReloadInfo(Math.random() * 60);
  };

  useEffect(() => {
    if (eventoActual) {
      setShowSaleBoton(eventoActual);
    }
  }, [eventoActual]);

  return (
    <>
      <div className="d-flex flex-column flex-xl-row">
        <div className="col-xl-12">
          {!showSaleForm ? (
            <div className={`card card-xxl-stretch mb-5 mb-xl-12`}>
              <div className="d-flex flex-column flex-xl-row">
                <div className="flex-lg-row-fluid">
                  <div className="card mb-6 mb-xl-9">
                    <div className="card-header border-0 pt-5 mt-4 d-flex">
                      <div className="card-title align-items-start flex-column flex-grow-1">
                        Compras y donativos realizados
                      </div>
                      <div className="text-end">
                        {showSaleBoton && (
                          <>
                            <button
                              type="button"
                              title="Nueva venta"
                              onClick={() => {
                                setShowSaleForm(!showSaleForm);
                              }}
                              className={`btn w-300px ${
                                !showSaleForm ? 'btn-primary' : 'btn-light'
                              }`}
                            >
                              <span className="indicator-label">
                                {!showSaleForm
                                  ? 'Nueva compra o donativo'
                                  : 'Cancelar'}
                              </span>
                            </button>
                          </>
                        )}
                      </div>
                    </div>

                    <div className="card-body">
                      <DonationGrid
                        reloadGrid={reloadInfo}
                        onDetails={(id: number) => {
                          if (id) {
                            setId(id);
                            setShowModal(true);
                          }
                        }}
                      ></DonationGrid>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}

          {showSaleForm ? (
            <div className="card">
              <div className="card-header pt-5">
                <h3 className="card-title align-items-start flex-column">
                  <span className="card-label fw-bold text-gray-800">
                    Nueva compra o donativo
                  </span>
                </h3>
              </div>
              <div className="card-body">
                <div className="row w-100 ">
                  <div className="col-md-12 ">
                    <DonationsForm
                      event_id={0}
                      handleClose={closeSecction}
                    ></DonationsForm>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
      <DetailModal
        show={showModal}
        handleClose={(updateGrid: boolean) => {
          setShowModal(!showModal);
          setId(0);
        }}
        id={id}
      ></DetailModal>
    </>
  );
};

export { ViewAE };
